import SingleDropdown from "@/components/common/single-dropdown/single-dropdown";
import { selectCategory } from "@/store/slices/category";
import { combineCategoryFilters } from "@/utils/combineCategoryFilters";
import { useRouter } from "next/router";
import React from "react";
import { useSelector } from "react-redux";

const PriceFilter = ({ isSearch }: any) => {
  const router = useRouter();
  const categoryState = useSelector(selectCategory);
  const priceFilters = [
    { label: "Below ₹ 10,000", value: { max: 10000 } },
    { label: "₹ 10,000 - ₹ 20,000", value: { min: 10000, max: 20000 } },
    { label: "₹ 20,000 - ₹ 30,000", value: { min: 20000, max: 30000 } },
    { label: "₹ 30,000 - ₹ 40,000", value: { min: 30000, max: 40000 } },
    { label: "₹ 40,000 - ₹ 50,000", value: { min: 40000, max: 50000 } },
    { label: "₹ 50,000 and Above", value: { min: 50000 } },
  ];

  const priceFilterChange = (value: any) => {
    if (isSearch) {
      router.replace(
        {
          pathname: "/jewellery",
          query: {
            ...combineCategoryFilters({
              ...router.query,
              priceMin: value.min,
              priceMax: value.max,
            }),
            q: router.query.q,
            try_it_online: router.query.try_it_online,
          },
        },
        undefined,
        { shallow: true }
      );
      return;
    }
    router.replace(
      {
        pathname: "/jewellery/category/[category]",
        query: {
          category: categoryState.data?.slug,
          ...combineCategoryFilters({
            ...router.query,
            priceMin: value.min,
            priceMax: value.max,
          }),
        },
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <SingleDropdown
      label="PRICE"
      items={priceFilters}
      onChange={priceFilterChange}
    />
  );
};

export default PriceFilter;
